import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  Modal,
  Pagination,
  PaginationItem,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/Iconify';
import { Link, json, useLocation, useNavigate } from 'react-router-dom';
import { Table } from '@material-ui/core';
import { api } from 'src/Api';
import AddDocumentModal from 'src/components/home/AddDocumentModal';
import DeleteIcon from '@mui/icons-material/Delete';

export default function Document() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const { service_id, service_name, docid, sub_service_id } = location.state || {};
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [saveLoading, setsaveLoading] = useState(false);
  const [loading, setloading] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [file, setFile] = useState([]);
  const [error, seterror] = useState('');
  const [savedisable, setsavedisable] = useState(false);
  const [openmodal, setOpenModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deletemodal, setDeleteModal] = useState(false);
  const [docdeleteid, setdocdeleteid] = useState('');
  console.log('service id and subservice', service_id);
  useEffect(() => {
    handleListDoc();
  }, [token]);

  const handleListDoc = () => {
    setFile([]);
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const params = new URLSearchParams();
    params.append('customer_service_id', docid);

    const url = `${api.get_service_document}?${params.toString()}`;

    const requestOptions = {
      headers: myHeaders,
      method: 'GET',
      redirect: 'follow'
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setFile(result?.data);
        } else {
          console.log('error doclist', result.message);
          seterror(result.message);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloading(false);
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const closeModal = () => setOpenModal(false);

  const handleDelete = (file_id) => {
    console.log('clg ', file_id);
    setDeleteLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    docid && formData.append('customer_service_id', docid);
    file_id && formData.append('file_id', docdeleteid);

    fetch(api.delete_service_document, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          handleListDoc();
          setDeleteModal(false);

          setDeleteLoading(false);
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setTimeout(() => {
            handleSnackbarClose();
          }, 2000);
          setDeleteLoading(false);
        }
      })
      .catch((error) => {
        setDeleteLoading(false);
        console.log('Fetch error:', error);
      });
  };

  const handleDeleteModal = () => {
    setDeleteModal(false);
  };
  const DeleteDocument = (docid) => {
    setDeleteModal(true);
    setdocdeleteid(docid);
    // handleDelete(docid);
  };
  return (
    <Page title={`Document | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack alignItems={'center'}>
            <Stack direction="row">
              <IconButton
                style={{
                  marginRight: 12,
                  height: 40,
                  width: 70,
                  borderRadius: 5,
                  backgroundColor: 'rgba(249, 0, 1,0.1)'
                }}
                onClick={() => navigate(-1)}
              >
                <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
              </IconButton>

              <div style={{ width: '100%' }}>
                <Typography variant="h4" sx={{ color: '#f90001' }}>
                  Document
                </Typography>
              </div>
            </Stack>
          </Stack>

          <Stack>
            <LoadingButton
              disabled={saveLoading || savedisable}
              loading={saveLoading}
              variant="contained"
              sx={{ alignSelf: 'end', fontSize: 11 }}
              //   onClick={handleSaveSteps}
              onClick={() => {
                setOpenModal(true);
              }}
            >
              Add Document
            </LoadingButton>
          </Stack>
          {/* )} */}
        </Stack>
        <Modal open={openmodal} onClose={closeModal}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '100vh'
            }}
          >
            <Box
              style={{
                width: '40%',
                backgroundColor: '#ffffff',
                boxShadow: 24,
                overflow: 'auto',
                padding: 10,
                borderRadius: 5,
                border: '2px solid #f90001'
              }}
            >
              <Typography variant="h6" color={'#f90001'} mb={1}>
                Upload A Document
              </Typography>
              <AddDocumentModal
                getserviceid={{
                  service_id: service_id,
                  sub_service_id: sub_service_id
                }}
                onClose={closeModal}
                adddocid={docid}
                getdata={() => {
                  setTimeout(() => {
                    closeModal();
                  }, 1000);
                  handleListDoc();
                }}
              />
            </Box>
          </Box>
        </Modal>
        <Dialog open={deletemodal} onClose={handleDeleteModal}>
          <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this document?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteModal} color="primary">
              No
            </Button>
            <LoadingButton
              loading={deleteLoading}
              variant="contained"
              onClick={handleDelete}
              color="primary"
              autoFocus
            >
              Yes
            </LoadingButton>
          </DialogActions>
        </Dialog>

        <Box mt={2}>
          <Card>
            {file && !loading && (
              <List>
                {file.map((doc, index) => (
                  <>
                    <Box p={1}>
                      <ListItem
                        style={{
                          height: 70,
                          backgroundColor: 'rgba(0,0,0,0.05)',
                          borderRadius: 5,
                          marginTop: 10
                        }}
                        key={index}
                        secondaryAction={
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-end'
                            }}
                          >
                            {doc?.uploaded_by == 'Company' ? (
                              <LoadingButton
                                // loading={deleteLoading && doc?.id === selectedId ? true : false}
                                style={{ width: 0, height: 30 }}
                                edge="end"
                                aria-label="delete"
                                onClick={() => DeleteDocument(doc?.id)}
                              >
                                {/* {!deleteLoading && doc?.id !== selectedId && ( */}

                                <DeleteIcon style={{ color: '#f90001', fontSize: 18 }} />
                                {/* )} */}
                              </LoadingButton>
                            ) : (
                              <div
                                style={{
                                  height: 30
                                }}
                              ></div>
                            )}
                            <p style={{ fontSize: 11, color: 'black' }}>{doc?.created_at}</p>
                          </Box>
                        }
                      >
                        <div>
                          <Link
                            to={doc?.url}
                            target="blank"
                            style={{ fontSize: 13, color: 'black' }}
                          >
                            {doc?.file_name}
                          </Link>
                          <p style={{ fontSize: 13, fontWeight: '500', color: '#f90001' }}>
                            Uploaded by: {doc?.uploaded_by}
                          </p>

                          <p style={{ fontSize: 13, fontWeight: '500', color: '#f90001' }}>
                            Step Name: {doc?.step || '-'}
                          </p>
                        </div>
                      </ListItem>
                    </Box>
                  </>
                ))}
              </List>
            )}
            {/* loader */}
            {loading && (
              <Box
                sx={{
                  height: '40vh',
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <CircularProgress />
              </Box>
            )}

            {file?.length == 0 && !loading && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '40vh'
                }}
              >
                <Typography color={'#ccc'}>{error}</Typography>
              </Box>
            )}
          </Card>

          <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
            <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Box>

        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
